
import { Component, Prop, Mixins, Watch } from "vue-property-decorator";
import { Bar } from "vue-chartjs";

@Component({
  extends: Bar
})
export default class SalesReportMonthlyChart extends Mixins(Bar) {
  @Prop({ required: true }) monthly!: any;

  mounted() {
    // 印刷時に黒塗りになってしまうのを防ぐ
    this.addPlugin({
      id: "custom-background-color",
      beforeDraw: (chart: any) => {
        const { ctx } = chart;
        ctx.save();
        ctx.globalCompositeOperation = "destination-over";
        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, chart.width, chart.height);
        ctx.restore();
      }
    });
    this.init();
  }

  @Watch("chartData")
  private init() {
    this.renderChart(this.chartData, {
      responsive: true,
      animation: { duration: 100 },
      maintainAspectRatio: false,
      scales: {
        yAxes: [
          {
            scaleLabel: {
              display: true,
              labelString: "金額(100万円)",
              fontSize: 16
            },
            id: "left-y-axis",
            ticks: {
              suggestedMax: 100000,
              suggestedMin: 0,
              stepSize: 100000,
              maxTicksLimit: 8,
              callback(value) {
                return `${value / 1000000}`;
              }
            }
          }
        ]
      },
      tooltips: {
        callbacks: {
          label(item) {
            return item.value || Number(item.value) === 0
              ? "￥" + Number(item.value).toLocaleString()
              : "";
          }
        }
      }
    });
  }

  private get chartData() {
    return {
      labels: this.labels,
      datasets: [
        {
          label: "利益額",
          type: "line",
          borderColor: "#F7B035",
          fill: false,
          data: this.profits,
          lineTension: 0,
          yAxisID: "left-y-axis"
        },
        {
          label: "請求総額",
          data: this.invoices,
          yAxisID: "left-y-axis"
        },
        {
          label: "発注総額",
          backgroundColor: "#2196F3",
          fill: false,
          data: this.purchases,
          yAxisID: "left-y-axis"
        }
      ]
    };
  }

  get labels() {
    return this.monthly.map((s: any) => s.month);
  }

  get invoices() {
    return this.monthly.map((s: any) => s.invoice);
  }

  get purchases() {
    return this.monthly.map((s: any) => s.purchase);
  }

  get profits() {
    return this.monthly.map((s: any) => s.profit);
  }
}
